import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { adminRequest } from "../../../utils/requestMethods";
import { BASE_URL } from "../../../utils/config";
import CustomForm from "../../../components/CustomForm/CustomForm";

const CreateTimeSlot = () => {
  const initialFormData = {
    startTime: "",
    endTime: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await toast.promise(
        adminRequest.post(`${BASE_URL}/timeSlot/create`, {
          startTime: formData.startTime,
          endTime: formData.endTime,
        }),
        {
          pending: "Processing your request",
        }
      );
      toast.success(response.data.message);

      setFormData(initialFormData);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const fields = [
    {
      name: "startTime",
      label: "Start Time",
      type: "time",
      value: formData.startTime,
      onChange: handleChange,
    },
    {
      name: "endTime",
      label: "End Time",
      type: "time",
      value: formData.endTime,
      onChange: handleChange,
    },
  ];
  return (
    <div>
      <CustomForm
        header="Create Time Slot"
        fields={fields}
        flexDirection="column"
        createButtonLabel="Create"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      <ToastContainer position="top-center" />
    </div>
  );
};

export default CreateTimeSlot;
